import { render, staticRenderFns } from "./editAddr.vue?vue&type=template&id=238ec7c0&scoped=true&"
import script from "./editAddr.vue?vue&type=script&lang=js&"
export * from "./editAddr.vue?vue&type=script&lang=js&"
import style0 from "./editAddr.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./editAddr.vue?vue&type=style&index=1&id=238ec7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ec7c0",
  null
  
)

export default component.exports